import { cuaWakeAssertionEnabledAtom } from '@/app-shell/rpa/cua-wake-assertion-preference';
import { useIsCuaWakeAssertionEnabled } from '@/features/flags/cua-wake-assertion-flag';
import { getDomains } from '@/helpers/getDomains';
import { logger } from '@/utils/logger/logger';
import { rpaBridge } from '@heidi/plugin-rpa';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

export const useSyncCuaWakeAssertionPreference = (): void => {
  const preference = useAtomValue(cuaWakeAssertionEnabledAtom);
  const flagEnabled = useIsCuaWakeAssertionEnabled();
  const enabled = flagEnabled && preference;

  useEffect(() => {
    if (!rpaBridge.isAvailable()) return;
    const baseUrl = getDomains().baseV2Url.replace(/\/$/, '');
    rpaBridge.setCuaWakeAssertionEnabled(enabled, baseUrl).catch((error) => {
      logger.warn('[cua-wake] Failed to push keep-awake preference', {
        error: error instanceof Error ? error.message : String(error),
      });
    });
  }, [enabled]);
};
